// src/components/Presidente/PresidenteList.jsx
import React, { useEffect, useState } from 'react';
import { listarPresidentes } from '../../services/presidenteService';

const PresidenteList = () => {
    const [presidentes, setPresidentes] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await listarPresidentes();
            setPresidentes(response.data);
        };
        fetchData();
    }, []);

    return (
        <div>
            <h2>Lista de Presidentes</h2>
            <ul>
                {presidentes.map((presidente) => (
                    <li key={presidente.id}>{presidente.usuario.nome} - {presidente.departamento}</li>
                ))}
            </ul>
        </div>
    );
};

export default PresidenteList;